import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';

@Injectable()
export class TooltipService {
    showTooltip: boolean = false;
    breakAll: boolean = false;

    isEllipsisActive($event: any, text: any = null) {
        const oWidth = $event.target.offsetWidth;
        const sWidth = $event.target.scrollWidth;
        if (oWidth < sWidth) {
            this.showTooltip = true;
        }
        else {
            this.showTooltip = false;
        }

        if (text && (text.length > 15) && (text.indexOf(' ') <= 0)) {
            this.breakAll = true;
        }
        else {
            this.breakAll = false;
        }
    }
}